interface TaskPillProps {
  /** How many protocols are scheduled for today. */
  taskCount: number;
  /** When the next one is due, already formatted for display. */
  nextTaskTime: string;
  /** Protocols added since the user last looked, shown as a badge. Hidden when zero. */
  newCount?: number;
}

/**
 * Today's protocols, in the navbar.
 *
 * Rendered as a div, not a button: there is no tasks screen to send anyone to yet, and a
 * focusable control that does nothing is worse for keyboard users than plain text. It becomes a
 * `Link` when that route exists.
 *
 * Hidden below `lg`, where the navbar has no room for it. gaia-app has no media queries at all -
 * it was built for desktop - and this app is installed on phones.
 */
export function TaskPill({ taskCount, nextTaskTime, newCount = 0 }: TaskPillProps) {
  return (
    <div
      className="hidden shrink-0 items-center gap-2 rounded-full bg-neutral-900 px-4 py-2
                 text-sm font-medium text-white lg:flex"
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-green-500" aria-hidden />
      <span>
        Start today&apos;s tasks · {taskCount} {taskCount === 1 ? "protocol" : "protocols"}
      </span>
      <span className="ml-2 text-neutral-400">{nextTaskTime}</span>
      {newCount > 0 && (
        <span className="rounded-full bg-neutral-700 px-2 py-px text-xs">+{newCount}</span>
      )}
    </div>
  );
}
